import {TestcacheActionTypes, apiActionsTestcache} from "./SupportActionConstants";
import authService from "../../auth/AuthService";

const updateTestcacheFilter = () => ({
    type: TestcacheActionTypes.FILTER_TESTCACHE_RECORDS
});

const setTestcacheFilter = (filterOption, filterType) => ({
    type: TestcacheActionTypes.SET_TESTCACHE_FILTER,
    payload: {filterOption, filterType}
});

const selectAllTestcacheRecords = (recordIds, isSelected) => ({
    type: TestcacheActionTypes.ALL_TESTCACHE_SELECTED,
    payload: {recordIds, isSelected},
});

const selectSomeTestcacheRecords = (recordId, isSelected) => ({
    type: TestcacheActionTypes.SOME_TESTCACHE_SELECTED,
    payload: {recordId, isSelected}
});

const toggleAddTestcacheModal = () => ({
    type: TestcacheActionTypes.TOGGLE_ADD_TESTCACHE_MODAL
});

const toggleEditTestcacheModal = () => ({
    type: TestcacheActionTypes.TOGGLE_EDIT_TESTCACHE_MODAL
});

const openEditTestcacheModal = (testcacheRecord) => ({
    type: TestcacheActionTypes.OPEN_EDIT_TESTCACHE_MODAL,
    payload: testcacheRecord
});

const setTestcacheForm = ({name, value}) => ({
    type: TestcacheActionTypes.SETTING_TESTCACHE_FORM_OBJECT_VALUE,
    payload: {name, value},
});

const setSourcesForTestcache = (sourceTypes) => ({
    type: TestcacheActionTypes.LOAD_SOURCE_TYPES,
    payload: sourceTypes,
});

const setDoBValue = ({day}) => ({
    type: TestcacheActionTypes.SET_DATE_OF_BIRTH,
    payload: {day}
});
const setTestcacheCountryValue = ({country}) => ({
    type: TestcacheActionTypes.SET_COUNTRY,
    payload: {country}
});
const setTestcacheSourceTypeValue = ({data_source_type}) => ({
    type: TestcacheActionTypes.SET_SOURCE_TYPE,
    payload: {data_source_type}
});
const generatePostmanRequest = () => ({
    type: TestcacheActionTypes.GENERATE_POSTMAN_REQUEST,
});

// API Action Constants for Testcache
const getTestcacheData = (authToken) => ({
    type: apiActionsTestcache.GET_ALL_TESTCACHE,
    payload: {authToken}
});

const setTestcacheData = (testcacheData) => ({
    type: apiActionsTestcache.SET_TESTCACHE_DB_TABLE_DATA,
    payload: testcacheData
});

const addNewTestcacheRecord = (authToken, testcacheObject) => ({
    type: apiActionsTestcache.ADD_TO_TESTCACHE,
    payload: {authToken, testcacheObject}
});
const editCurrentTestcacheRecord = (authToken, testcacheObject, testcacheGUID) => ({
    type: apiActionsTestcache.EDIT_TESTCACHE,
    payload: {authToken, testcacheObject, testcacheGUID}
});
const deleteCurrentTestcacheRecord = (authToken, testcacheGUID) => ({
    type: apiActionsTestcache.DELETE_TESTCACHE,
    payload: {authToken, testcacheGUID}
});
const deleteWarningForTestcacheRecord = (testcacheGUID) => ({
    type: apiActionsTestcache.DELETE_WARNING_FOR_TESTCACHE,
    payload: testcacheGUID
});


const unmountTestcacheDetails = () => ({
    type: TestcacheActionTypes.CLEAR_TESTCACHE_DETAILS
});


/**
 * ACTION TO CLEAR THE TESTCACHE DETAILS FROM REDUX STORE
 * */
export function unmountTestcache() {
    return (dispatch) => {
        dispatch(unmountTestcacheDetails());
    }
}

/**
 * ACTION TO GET THE TESTCACHE DB_IDENTITY TABLE
 * */
export function fetchTestcacheTableData() {
    return async (dispatch) => {
        const authToken = await authService.idUser();
        dispatch(getTestcacheData(authToken));
    }
}

/**
 * ACTION TO SET THE TESTCACHE DATA FOR LIST PAGE.
 * */
export function testcacheTableDataSuccess(testcacheData) {
    return (dispatch) => {
        dispatch(setTestcacheData(testcacheData));
    }
}

/**
 * ACTION TO SET THE TESTCACHE FILTER VALUE.
 * */
export function setTestcacheRecordsFilter(filterOption, filterType) {
    return (dispatch) => {
        dispatch(setTestcacheFilter(filterOption, filterType));
    }
}

/**
 * ACTION TO FILTER THE RECORDS BASED ON CURRENT FILTER VALUES.
 * */
export function updateTestcacheFilters() {
    return (dispatch) => {
        dispatch(updateTestcacheFilter())
    };
}

export function selectAllTestcache(recordIds, isSelected) {
    return (dispatch) => {
        dispatch(selectAllTestcacheRecords(recordIds, isSelected))
    }
}

export function selectSomeTestcache(recordId, isSelected) {
    return (dispatch) => {
        dispatch(selectSomeTestcacheRecords(recordId, isSelected))
    }
}

export function generatePostmanReq() {
    return (dispatch) => {
        dispatch(generatePostmanRequest())
    }
}

export function toggleAddTestcacheRecordsModal() {
    return (dispatch) => {
        dispatch(toggleAddTestcacheModal())
    }
}

export function openEditTestcacheRecordsModal(testcacheRecord) {
    return (dispatch) => {
        dispatch(openEditTestcacheModal(testcacheRecord))
    }
}

export function toggleDeleteTestcacheRecordsModal(testcacheGUID) {
    return (dispatch) => {
        dispatch(deleteWarningForTestcacheRecord(testcacheGUID))
    }
}

export function toggleEditTestcacheRecordsModal() {
    return (dispatch) => {
        dispatch(toggleEditTestcacheModal())
    }
}

export function setTestcacheFormValues({name, value}) {
    return (dispatch) => {
        dispatch(setTestcacheForm({name, value}));
    }
}

export function loadSourcesForTestcache(sourceTypes) {
    return (dispatch) => {
        dispatch(setSourcesForTestcache(sourceTypes))
    }
}

export function addTestcacheRecord(testcacheObject) {
    return async (dispatch) => {
        const authToken = await authService.idUser();
        dispatch(addNewTestcacheRecord(authToken, testcacheObject))
    }
}

export function editTestcacheRecord(testcacheObject, testcacheGUID) {
    return async (dispatch) => {
        const authToken = await authService.idUser();
        dispatch(editCurrentTestcacheRecord(authToken, testcacheObject, testcacheGUID))
    }
}

export function deleteTestcacheRecord(testcacheGUID) {
    return async (dispatch) => {
        const authToken = await authService.idUser();
        dispatch(deleteCurrentTestcacheRecord(authToken, testcacheGUID))
    }
}

export function setDateOfBirthTestcache({day}) {
    return (dispatch) => {
        dispatch(setDoBValue({day}));
    }
}

export function setTestcacheCountry({country}) {
    return (dispatch) => {
        dispatch(setTestcacheCountryValue({country}));
    }
}

export function setTestcacheSourceType({data_source_type}) {
    return (dispatch) => {
        dispatch(setTestcacheSourceTypeValue({data_source_type}));
    }
}

const exports = {
    apiActionsTestcache,
    TestcacheActionTypes,
}

export default exports;
